import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import MentalHealthAndSubstanceAbuseDetails from '../../subdepartmentdetails/MentalHealthAndSubstanceAbuse'


function MentalHealthAndSubstanceAbuse() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Mental Health and Substance Abuse Services || Health and Human Services";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Health Human Services"
            title="Mental Health & Wellness Resources"
            subtitledown="Department of Health & Human Services"
           />
            <MentalHealthAndSubstanceAbuseDetails/>
        </div>
    </>
  )
}

export default MentalHealthAndSubstanceAbuse